// extracted by mini-css-extract-plugin
export default {"popup":"historicalHazardPopup_popup__uGf0i"};